import { render } from "./CheckoutConfirm.vue?vue&type=template&id=3b06acaa&scoped=true"
import script from "./CheckoutConfirm.vue?vue&type=script&lang=js"
export * from "./CheckoutConfirm.vue?vue&type=script&lang=js"

import "./CheckoutConfirm.vue?vue&type=style&index=0&id=3b06acaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b06acaa"]])

export default __exports__